import request from "./request";
import excludedUpcs from "../constants/ExcludedUpcs";
import prioritizedUpcsByCategory from "../constants/PrioritizedUpcsByCategory";
import specialCategoryConfig from "../constants/SpecialCategoryConfig";
import {
  DEFAULT_RALPHS_LOCATION_ID,
  RALPHS_COMPANY_NAME,
} from "../constants/RalphsStore";


const getKrogerStoreLocation = async (lat, lng, activeTab = null) => {
  localStorage.setItem('isCalledStore', 'yes');
  const { data } = await request.get(`/kroger/location?lat=${lat}&lng=${lng}&tab=${activeTab}`)
  localStorage.setItem('store', JSON.stringify(data))
  if (activeTab === 'null' || !activeTab || activeTab === 'Ralphs') {
    localStorage.setItem("locationId", JSON.stringify(data.store.locationId));

    // storing the Store Location 
    localStorage.setItem("storeLocation", JSON.stringify(`${data.store.address.addressLine1}, ${data.store.address.city}`));
    localStorage.setItem("storeLat", JSON.stringify(data.store.geolocation.latitude));
    localStorage.setItem("storeLng", JSON.stringify(data.store.geolocation.longitude));

    // returning the location Id of Kroger Shop
    return data.store.locationId;
  } else {
    if (data) {
      localStorage.setItem("storeLocation", JSON.stringify(`${data.store.name}, ${data.store.vicinity}`));
      localStorage.setItem("storeLat", JSON.stringify(data.store.geometry.location.lat));
      localStorage.setItem("storeLng", JSON.stringify(data.store.geometry.location.lng));
    }
  }
}

const normalizeLocationId = (value) => {
  if (value === null || value === undefined) return null;

  let normalized = value;
  if (typeof normalized === "string") {
    normalized = normalized.trim();
    if (!normalized || normalized === "undefined" || normalized === "null") {
      return null;
    }

    if (normalized.startsWith('"') && normalized.endsWith('"')) {
      try {
        normalized = JSON.parse(normalized);
      } catch {
        // Keep the original string and validate it below.
      }
    }
  }

  const asString = String(normalized).trim();
  return /^\d+$/.test(asString) ? asString : null;
};

const readStoredProperty = () => {
  try {
    const raw = localStorage.getItem("property");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const readPropertyRalphsLocationId = () => {
  const property = readStoredProperty();
  const stores = property?.stores;
  if (!stores || typeof stores !== "object") return null;

  const ralphsKey = Object.keys(stores).find(
    (key) => String(key).trim().toLowerCase() === RALPHS_COMPANY_NAME.toLowerCase()
  );

  return normalizeLocationId(
    ralphsKey ? stores?.[ralphsKey]?.storeId : null
  );
};

// Reads the persisted Kroger locationId. Leading zeros are preserved.
const readStoredLocationId = () => {
  try {
    return normalizeLocationId(localStorage.getItem("locationId"));
  } catch {
    return null;
  }
};

export const resolveRalphsLocationId = () => {
  const locationId =
    readPropertyRalphsLocationId() ||
    readStoredLocationId() ||
    DEFAULT_RALPHS_LOCATION_ID;

  // Keep every downstream Kroger call on the same resolved store when storage
  // is available. Storage failure must never suppress the Kroger request.
  try {
    localStorage.setItem("locationId", locationId);
  } catch {
    // Continue with the resolved in-memory fallback.
  }
  return locationId;
};

const getProductsKroger = async (term, start = 0, limit = 10) => {
  // Bellhopt currently supports Ralphs/Kroger only. Always attempt the Kroger
  // request using: property-specific Ralphs store -> saved location -> default.
  const locationId = resolveRalphsLocationId();

  const { data } = await request.get(`/kroger/products?term=${term}&start=${start}&limit=${limit}&locationId=${locationId}`);
    // Filter out excluded UPCs
    if (data && data.data && Array.isArray(data.data)) {
      data.data = data.data.filter((item) => !excludedUpcs.includes(item.upc));
    
      // Sort products to prioritize specific UPCs for this category
      // Check both specialCategoryConfig and prioritizedUpcsByCategory for prioritized UPCs
      const specialConfig = specialCategoryConfig[term];
      const prioritizedUpcs = specialConfig?.prioritizedUpcs || prioritizedUpcsByCategory[term];
      
      if (prioritizedUpcs && prioritizedUpcs.length > 0) {
        data.data.sort((a, b) => {
          const aIndex = prioritizedUpcs.indexOf(a.upc);
          const bIndex = prioritizedUpcs.indexOf(b.upc);
          
          // If both are prioritized, maintain their order in the prioritized array
          if (aIndex !== -1 && bIndex !== -1) {
            return aIndex - bIndex;
          }
          // If only a is prioritized, it comes first
          if (aIndex !== -1) {
            return -1;
          }
          // If only b is prioritized, it comes first
          if (bIndex !== -1) {
            return 1;
          }
          // If neither is prioritized, maintain original order
          return 0;
        });
      }
    }
    
    if (data && data.data && Array.isArray(data.data)) {
      data.data.forEach((item, index) => {
      // Add category and index to product for markup calculation
      item._categoryName = term;
      item._categoryIndex = start + index;
      // if(item.description.toLowerCase().includes("melon") && item.items[0].soldBy === "WEIGHT") {
      //   item.items[0].soldBy = "UNIT";
      //   item.items[0].price.regular = Number((item.items[0].price.regular * 5).toFixed(2));
      // }
      // else 
      if (item.upc === "0000000003094" && item.items[0].soldBy === "WEIGHT") {
        item.items[0].soldBy = "UNIT";
        let price = Number((item.items[0].price.regular * 2.5).toFixed(2));
        item.items[0].price.regular = price;
      }
      else if (item.upc === "0000000004023" && item.items[0].soldBy === "WEIGHT") {
        item.items[0].soldBy = "UNIT";
        let price = Number((item.items[0].price.regular * 2).toFixed(2));
        item.items[0].price.regular = price;
      }
      else if (item.upc === "0000000003907" && item.items[0].soldBy === "WEIGHT") {
        item.items[0].soldBy = "UNIT";
        let price = Number((item.items[0].price.regular * 2).toFixed(2));
        item.items[0].price.regular = price;
      }
      else if (item.upc === "0000000003093" && item.items[0].soldBy === "WEIGHT") {
        item.items[0].soldBy = "UNIT";
        let price = Number((item.items[0].price.regular * 2.5).toFixed(2));
        item.items[0].price.regular = price;
      }
      else if (item.upc === "0000000004022" && item.items[0].soldBy === "WEIGHT") {
        item.items[0].soldBy = "UNIT";
        let price = Number((item.items[0].price.regular * 2).toFixed(2));
        item.items[0].price.regular = price;
      }
      else if (item.upc === "0000000004056" && item.items[0].soldBy === "WEIGHT") {
        item.items[0].soldBy = "UNIT";
        let price = Number((item.items[0].price.regular * 2).toFixed(2));
        item.items[0].price.regular = price;
      }
      else if (item.upc === "0000000004069" && item.items[0].soldBy === "WEIGHT") {
        item.items[0].soldBy = "UNIT";
        let price = Number((item.items[0].price.regular * 2.5).toFixed(2));
        item.items[0].price.regular = price;
      }
      else if (item.upc === "0000000094664" && item.items[0].soldBy === "WEIGHT") {
        item.items[0].soldBy = "UNIT";
        let price = Number((item.items[0].price.regular * 1.34).toFixed(2));
        item.items[0].price.regular = price;
      }
      else if (item.upc === "0000000094629" && item.items[0].soldBy === "WEIGHT") {
        item.items[0].soldBy = "UNIT";
        let price = Number((item.items[0].price.regular * 2).toFixed(2));
        item.items[0].price.regular = price;
      }
      else if (item.upc === "0000000094554" && item.items[0].soldBy === "WEIGHT") {
        item.items[0].soldBy = "UNIT";
        let price = Number((item.items[0].price.regular * 2.5).toFixed(2));
        item.items[0].price.regular = price;
      }
      else if (item.description.toLowerCase().includes("grape") && item.items[0].soldBy === "WEIGHT") {
        item.items[0].soldBy = "UNIT";
        item.items[0].price.regular = Number((item.items[0].price.regular * 2).toFixed(2));
      }
      });
    }

    return data;
}

const getProductDetailsKroger = async (id) => {
  const locationId = resolveRalphsLocationId();

  const { data } = await request.get(`/kroger/product?locationId=${locationId}&id=${id}`);
    // Check if UPC is excluded
    if (excludedUpcs.includes(data.data.upc)) {
      return null;
    }
    if (data.data.upc === "0000000003094" && data.data.items[0].soldBy === "WEIGHT") {
      data.data.items[0].soldBy = "UNIT";
      let price = Number((data.data.items[0].price.regular * 2.5).toFixed(2));
      data.data.items[0].price.regular = price;
    }
    else if (data.data.upc === "0000000004023" && data.data.items[0].soldBy === "WEIGHT") {
      data.data.items[0].soldBy = "UNIT";
      let price = Number((data.data.items[0].price.regular * 2).toFixed(2));
      data.data.items[0].price.regular = price;
    }
    else if (data.data.upc === "0000000003907" && data.data.items[0].soldBy === "WEIGHT") {
      data.data.items[0].soldBy = "UNIT";
      let price = Number((data.data.items[0].price.regular * 2).toFixed(2));
      data.data.items[0].price.regular = price;
    }
    else if (data.data.upc === "0000000003093" && data.data.items[0].soldBy === "WEIGHT") {
      data.data.items[0].soldBy = "UNIT";
      let price = Number((data.data.items[0].price.regular * 2.5).toFixed(2));
      data.data.items[0].price.regular = price;
    }
    else if (data.data.upc === "0000000004022" && data.data.items[0].soldBy === "WEIGHT") {
      data.data.items[0].soldBy = "UNIT";
      let price = Number((data.data.items[0].price.regular * 2).toFixed(2));
      data.data.items[0].price.regular = price;
    }
    else if (data.data.upc === "0000000004056" && data.data.items[0].soldBy === "WEIGHT") {
      data.data.items[0].soldBy = "UNIT";
      let price = Number((data.data.items[0].price.regular * 2).toFixed(2));
      data.data.items[0].price.regular = price;
    }
    else if (data.data.upc === "0000000004069" && data.data.items[0].soldBy === "WEIGHT") {
      data.data.items[0].soldBy = "UNIT";
      let price = Number((data.data.items[0].price.regular * 2.5).toFixed(2));
      data.data.items[0].price.regular = price;
    }
    else if (data.data.upc === "0000000094664" && data.data.items[0].soldBy === "WEIGHT") {
      data.data.items[0].soldBy = "UNIT";
      let price = Number((data.data.items[0].price.regular * 1.34).toFixed(2));
      data.data.items[0].price.regular = price;
    }
    else if (data.data.upc === "0000000094629" && data.data.items[0].soldBy === "WEIGHT") {
      data.data.items[0].soldBy = "UNIT";
      let price = Number((data.data.items[0].price.regular * 2).toFixed(2));
      data.data.items[0].price.regular = price;
    }
    else if (data.data.upc === "0000000094554" && data.data.items[0].soldBy === "WEIGHT") {
      data.data.items[0].soldBy = "UNIT";
      let price = Number((data.data.items[0].price.regular * 2.5).toFixed(2));
      data.data.items[0].price.regular = price;
    }
    else if (data.data.description.toLowerCase().includes("grape") && data.data.items[0].soldBy === "WEIGHT") {
      data.data.items[0].soldBy = "UNIT";
      data.data.items[0].price.regular = Number((data.data.items[0].price.regular * 2).toFixed(2));
    }
    
    // Restore category info from localStorage if available (for consistent pricing on detail page)
    const categoryInfoKey = `productCategory_${data.data.productId}`;
    const storedCategoryInfo = localStorage.getItem(categoryInfoKey);
    if (storedCategoryInfo) {
      try {
        const categoryInfo = JSON.parse(storedCategoryInfo);
        data.data._categoryName = categoryInfo.categoryName;
        data.data._categoryIndex = categoryInfo.categoryIndex;
      } catch (e) {
        // If parsing fails, ignore
      }
    }
    
    return data.data;
}

const getGuestProperty = async (pid) => {
  localStorage.removeItem('isCalledStore');
  try {
    const { data } = await request.get(`/properties/guest/${pid}`);
    localStorage.setItem("property", JSON.stringify(data));

    return data._id;
  } catch (err) {
    throw err;
  }
}

export { getProductsKroger, getProductDetailsKroger, getGuestProperty, getKrogerStoreLocation }
